var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightAreasClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,3.6c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3S5.6,3.6,4.9,3.6z M4.9,7.2 c-1.2,0-2.2-1-2.2-2.3s1-2.2,2.2-2.2s2.3,1,2.3,2.2S6.2,7.2,4.9,7.2z M2.2,0.9c-0.7,0-1.3,0.6-1.3,1.3V8c0,0.9,0.5,2.1,1.1,2.7 l9.9,9.9c0.5,0.5,1.3,0.5,1.8,0l6.8-6.8c0.2-0.2,0.4-0.6,0.4-0.9s-0.1-0.7-0.4-0.9l-9.9-9.9C10.1,1.5,8.9,0.9,8,0.9H2.2z M12.9,22 c-0.6,0-1.2-0.2-1.6-0.6l-9.9-10C0.6,10.6,0,9.1,0,8V2.2C0,1,1,0,2.2,0H8c1.1,0,2.6,0.6,3.4,1.4l9.9,9.9c0.4,0.4,0.6,1,0.6,1.6 c0,0.6-0.2,1.2-0.6,1.6l-6.8,6.8C14.1,21.8,13.5,22,12.9,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightAreasClicked);
export default __webpack_public_path__ + "static/media/insight_areas_clicked.5e893d9b4a59e3dbabd214dcc7cc5450.svg";
export { ForwardRef as ReactComponent };